import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../button/Button';
import Text from '../text/Text'
import './styles.css';

export const Galery = () => {
    return(        
        <div className='container'>
            <div className='content' id='content-center'>
                <Text as='h1' fontSize={56} variant='yellow-red'>Galeria de Fotos</Text>
                <div className='galery-content'>
                    <div className='galery-column'>
                        <img src="/galery-images/IMG-20240802-WA0016.jpg" alt="photo" className='image1'/>
                        <img src="/galery-images/_EXU0655.jpg" alt="photo" className='image1' />
                    </div>
                    <div className='galery-column'>
                        <img src="/galery-images/_EXU0796 1.png" alt="photo" className='image2' />
                        <img src="/galery-images/_EXU0677.jpg" alt="photo" className='image2' />
                        <img src="/galery-images/_EXU0593.jpg" alt="photo" className='image1' />
                    </div>
                    <div className='galery-column'>
                        <img src="/galery-images/_EXU0483.jpg" alt="photo" className='image1' id='position-left'/>
                        <img src="/galery-images/_EXU0641.jpg" alt="photo" className='image1' />
                    </div>
                </div>
                <Link to='/fotos'>
                    <Button variant='gradient'>Carregar Mais</Button>
                </Link>
                
            </div>
        </div>
    )
}

export const AllGalery = () => {
    return(        
        <div className='container'>
            <div className='content' id='content-center'>
                <Text as='h1' fontSize={56} variant='yellow-red'>Fotos</Text>
                <div className='galery-content'>
                    <div className='galery-column'>
                        <img src="/galery-images/IMG-20240802-WA0016.jpg" alt="photo" className='image1'/>
                        <img src="/galery-images/_EXU0655.jpg" alt="photo" className='image1' />
                        <img src="/galery-images/_EXU0510.jpg" alt="photo" className='image1'/>
                        <img src="/galery-images/_EXU0294.jpg" alt="photo" className='image1' />
                    </div>
                    <div className='galery-column'>
                        <img src="/galery-images/_EXU0796 1.png" alt="photo" className='image2' />
                        <img src="/galery-images/_EXU0677.jpg" alt="photo" className='image2' />
                        <img src="/galery-images/_EXU0593.jpg" alt="photo" className='image1' />
                        <img src="/galery-images/_EXU0122.jpg" alt="photo" className='image2'/>
                        <img src="/galery-images/_EXU0435.jpg" alt="photo" className='image2' />
                        <img src="/galery-images/_EXU0431.jpg" alt="photo" className='image2'/>
                    </div>
                    <div className='galery-column'>
                        <img src="/galery-images/_EXU0483.jpg" alt="photo" className='image1' id='position-left'/>
                        <img src="/galery-images/_EXU0641.jpg" alt="photo" className='image1' />
                        <img src="/galery-images/_EXU0815.jpg" alt="photo" className='image1'/>
                        <img src="/galery-images/_EXU0829.jpg" alt="photo" className='image1' />
                    </div>
                </div>
            </div>
        </div>
    )
}
